import { useUserGradeHistoriesQuery } from '../queries/useUserGradeHistoriesQuery';
import { USER_GRADE_HISTORY_MODEL } from '../models';
import toastMsg from '../../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../../constants/service/toastMsg/accountUserToastMsg';
import { setDateFormat } from '../../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import { gradeCreateFromDate, gradeCreateToDate } from '../helpers';
import { UserGradeHistoryItemType } from '../types';

export interface IUserGradeHistoriesViewModel {
  histories: UserGradeHistoryItemType[];
}

export const useUserGradeHistoriesViewModel = (userId: number, isActive: boolean): IUserGradeHistoriesViewModel => {
  const { data } = useUserGradeHistoriesQuery<UserGradeHistoryItemType[]>({
    userId,
    options: {
      enabled: !!userId && isActive,
      placeholderData: USER_GRADE_HISTORY_MODEL,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_GRADE_HISTORY_REQUEST_SUCCESS),
      onError: (err) => {
        toastMsg.error(accountUserToastMsg.GET_USER_DETAIL_GRADE_HISTORY_REQUEST_ERROR, err);
      },
      select: (result) => {
        //유저등급 히스토리에서 사용하는 데이터(날짜,등급 산정 기간,등급)에 맞게 포맷하여 리턴
        return result.userGradeHistories.map((userGradeHistory) => ({
          gradeName: userGradeHistory.name,
          createDate: setDateFormat(userGradeHistory.createDate, DATE_FORMAT.YM_DOT_FORMAT),
          gradeCreatePeriod: `${gradeCreateFromDate(
            userGradeHistory.createDate,
            userGradeHistory.periodMonth,
          )} ~ ${gradeCreateToDate(userGradeHistory.createDate)}`,
        }));
      },
    },
  });

  return { histories: data || [] };
};
